var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"lg":"7"}},[_c('p',[_vm._v("Please fill out all fields to upload ID and verify your account.")])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"3"}},[_c('router-link',{staticClass:"button--primary",attrs:{"to":{ name: 'ProfileEditData' }}},[_vm._v("Edit data")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f1e4f59e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/partials/section/content/profile/verification/EditData.vue
// module id = CZFb
// module chunks = 0